import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../shared/services/auth.service";
import { FormBuilder, FormGroup } from '@angular/forms';
import { MessageService } from '../../shared/services/messages.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html'
})

export class SignUpComponent implements OnInit {
  myForm: FormGroup;
  uploadedFiles: any[] = [];

  constructor(
    public authService: AuthService,
    public messageService: MessageService,
    private signup: FormBuilder
  ) { }

  ngOnInit() { 
    this.myForm = this.signup.group({
      name: '',
      email: '',
      password: '',
      url: '',
    });

    this.messageService.clear();
  }

  onUpload(event) {
    for(let file of event.files) {
        this.uploadedFiles.push(file);
        console.log(file);
    }

    this.messageService.add("Something went wrong");
}

  signUp(){
    this.authService.SignUp(this.myForm.value.name, this.myForm.value.email, this.myForm.value.password, this.myForm.value.url)
  }
}